<div>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Filter: <input type="text" #filter />
  &nbsp;&nbsp;&nbsp;Ladder:
  <select [(ngModel)]="ladderId">
    <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.name}} ({{l.ladderId}})</option>
  </select>
  &nbsp;&nbsp;&nbsp;<a href="#" (click)="clear($event)">Clear Impersonation</a>
  <table class="table">
    <thead>
      <tr>
        <th>Id</th>
        <th>Name</th>
        <th>Nickname</th>
      </tr>
    </thead>
    <tbody>
    <tr *ngFor="let p of players | byname: filter.value">
      <td style="font-family:'Courier New', Courier, monospace"><a href="#" (click)=" impersonate($event, p.id)">{{p.id}}</a></td>
      <td>{{p.getFullName()}}</td>
      <td style="white-space:nowrap;">
        <input type="text" maxlength="100" [(ngModel)]="p.nickname" [disabled]="savingNicknameUserId === p.id" style="width:14em;max-width:50vw;margin-right:6px;" />
        <button type="button" (click)="setNickname(p)" [disabled]="savingNicknameUserId === p.id">Set</button>
        <span *ngIf="nicknameInline[p.id] as hint" [style.color]="hint.ok ? '#0a6b0a' : '#b00020'" style="margin-left:8px;font-size:0.9em;">{{ hint.text }}</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>